import type { InternalAxiosRequestConfig } from 'axios'
import { useUiStore } from '@/stores/ui.store'

export function languageInterceptor(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  const ui = useUiStore()
  config.headers.set('Accept-Language', ui.locale)
  return config
}
